import React, {useState, useEffect} from "react";
import apiJson from "../helper/axios";
import { textPopUp } from "../function/swal";
import {Link} from "react-router-dom";

export const AboutComponent = () => {

    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [email, setEmail] = useState('');
    const onHandleFirstname = (e) => {
        const target = e.target.value;
        setFirstname(target)
    }

    const onHandleLastname = (e) => {
        const target = e.target.value;
        setLastname(target)
    }

    const onHandleEmail = (e) => {
        const target = e.target.value;
        setEmail(target)
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        const postData = new FormData();
        postData.append("firstname", firstname);
        postData.append("lastname", lastname);
        postData.append("email", email);
        postData.append("type", "subscribe");
        postData.append("from_where", "metal_detector");

        try {
            if (firstname === "" || lastname === "" || email === "") return  textPopUp("Error", "Terjadi kesalahan", "error");
            const response = await apiJson.post("/emails-list/save", postData)
            if (response.data.status === 200 || response.status === 200) {
                localStorage.setItem("email_member" , email);
                setFirstname("")
                setLastname("")
                setEmail("")
                textPopUp("Success", "Berhasil berlangganan menjadi member kami", "success");
            }
        } catch (err) {
            textPopUp("Error", "Terjadi kesalahan", "error");
        }
    };

    let emailMember = localStorage.getItem("email_member");


    return(
        <>
            <div className={"w-full  py-4"}>
                <section id={"newsletter"}>
                    <div className={""}>
                        <div className={"w-full main-bg-clip-2-mini md:main-bg-clip-2"}>
                            {emailMember ? (
                                <>
                                <div className={"w-full mx-auto mt-10"}  style={{maxWidth:"1500px"}}>
                                    <div className={"w-11/12 md:-11/12 lg:w-8/12 text-center mx-auto "}>
                                        <div className={"pt-17 md:pt-"}>
                                            <h2 className="text-white text-2xl font-semibold">
                                                Terima kasih telah bergabung!
                                            </h2>
                                            <p className="text-white text-xl font-light">
                                                Anda akan menerima informasi promo, penawaran, dan berita terkini di kotak masuk email Anda.
                                            </p>
                                        </div>

                                    </div>
                                </div>
                                </>
                            ): (
                                <div className={"w-full mx-auto"}  style={{maxWidth:"1500px"}}>
                                    <div className={"pt-17 md:pt-6 pb-4"}>
                                        <div className={"w-full md:w-6/12 pt-10  md:pt-6 pb-3 md:pb-4 mx-auto"}>
                                            <div className={"text-center flex items-center"}>
                                                <div className={"border-r pe-6 ms-auto border-gray-200"}>
                                                    <h1 className={"text-white text-2xl md:text-3xl font-semibold "}>
                                                        MEMBER KAMI</h1>
                                                </div>
                                                <div className={"ps-6 me-auto"}>
                                                    <h4 className={"text-white font-semibold text-md"}>D A F T A R</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"w-11/12 md:-11/12 lg:w-8/12 text-center mx-auto "}>
                                        <div>
                                            <div className={""}>
                                                <p className={"text-white font-extralight "}>
                                                    Dapatkan promo, penawaran, dan berita terbaru langsung di kotak masuk email Anda
                                                </p>
                                            </div>
                                            <div className={"w-full mt-10 md:mt-4"}>
                                                <form onSubmit={handleSubmit}>
                                                    <div className="w-full block md:flex">
                                                        {/* First Name Input */}
                                                        <div className="w-full my-0 md:my-5 md:-6/12 lg:w-3/12">
                                                            <input
                                                                onChange={onHandleFirstname}
                                                                value={firstname}
                                                                className="w-full py-3 text-sm font-light px-3 border border-gray-200"
                                                                placeholder="Nama Depan"
                                                                required
                                                            />
                                                        </div>

                                                        {/* Last Name Input */}
                                                        <div className="w-full my-5 md:-6/12 lg:w-3/12">
                                                            <input
                                                                onChange={onHandleLastname}
                                                                value={lastname}
                                                                className="w-full py-3 text-sm font-light px-3 border border-gray-200"
                                                                placeholder="Nama Belakang"
                                                                required
                                                            />
                                                        </div>

                                                        {/* Email Input */}
                                                        <div className="w-full my-5  md:-6/12 lg:w-3/12">
                                                            <input
                                                                onChange={onHandleEmail}
                                                                value={email}
                                                                className="w-full py-3 text-sm font-light px-3 border border-gray-200"
                                                                placeholder="Alamat Email"
                                                                type="email"
                                                                required
                                                            />
                                                        </div>

                                                        {/* Submit Button */}
                                                        <div className="w-full my-5 md:-6/12 lg:w-3/12">
                                                            <button
                                                                type="submit"
                                                                className="btn-main-3 text-center md:text-left w-full py-3 px-5"
                                                                aria-label="Subscribe to the newsletter"
                                                            >
                                                                <p className="text-sm mx-auto font-medium">BERLANGGANAN</p>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            )}
                        </div>

                    </div>
                </section>

            </div>
        </>
    )
}

export const InformationComponent = () => {

    const [isExpand, setIsExpand] = useState(false)
    const onChangeExpand = () => {
        setIsExpand(!isExpand)
    }

    return(
        <>
            <div  className={"pt-2 "}>
                <section  id="about-us" style={{maxWidth:"1500px"}} className="w-11/12 md:w-11/12  mt-2 md:mt-4 mx-auto flex flex-col md:px-8 lg:flex-row items-center justify-between px-0  pt-32 pb-10 bg-white">
                     <div className="cursor-pointer  w-99 mx-auto py-5 block lg:flex    items-center md:items-start text-center md:text-left">
                        <div className="flex   flex-row gap-2 md:gap-5 w-full lg:w-4/12">
                            <img
                                src="/assets/bann/banner-2.png"
                                alt="Team Discussion"
                                className="rounded-lg shadow-md transition-transform duration-300 ease-in-out hover:-translate-y-2 -mt-14 h-60 md:h-80 object-cover ms-auto w-1/2 lg:w-6/12"
                            />
                            <img
                                src="/assets/bann/banner-4.jpg"
                                alt="Work Environment"
                                className="rounded-lg shadow-md transition-transform duration-300 ease-in-out hover:-translate-y-2 h-60 md:h-80 object-cover me-auto w-1/2  lg:w-6/12"
                            />
                        </div>
                        <div className="lg:w-8/12 md:rounded-lg md:border transition-transform duration-300 ease-in-out hover:-translate-y-2 border-gray-100 pt-4 md:pt-8 pb-4 md:shadow mt-4 md:mt-8 md:shadow-gray-200 lg:mt-0 lg:ml-12">
                            <div className={"w-full md:w-11/12 mx-auto text-left"}>
                                <h2 className="text-indigo-600 font-semibold mb-2">Tentang UNIMAX</h2>
                                <h1 className="text-lg md:text-xl font-bold mb-4 text-gray-900">
                                    Menyediakan layanan solusi Dukungan Industri yang Disesuaikan dengan Kebutuhan produksi Anda
                                </h1>
                                <p className="md:text-md text-md text-gray-600 mb-6">
                                    Unimax adalah <b>Global Brand</b> yang berorientasi pada teknologi modern, yang mengintegrasikan <b>produksi</b>, <b>penelitian & pengembangan (R&D)</b>, <b>penjualan</b>, dan <b>layanan</b> untuk menyediakan solusi pengujian industri tingkat tinggi.

                                    Spesialisasi kami meliputi produk-produk seperti:
                                    - <b>Checkweigher</b>
                                    - <b>Metal Detector</b>
                                    - <b>X-Ray Inspection</b>
                                    - <b>Camera Vision Systems</b>

                                    Solusi ini dirancang khusus untuk industri <b>makanan</b>, <b>obat-obatan</b>, <b>bahan kimia sehari-hari</b>, <b>suku cadang mobil</b>, dan proyek <b>teknik lainnya</b>.
                                </p>
                                {isExpand && (
                                    <div className="transition-all duration-500 ease-in-out max-h-screen opacity-100">
                                        <p className="text-md text-gray-600 mb-6">
                                            Diperkuat oleh <b>produksi berbasis di Shanghai, Tiongkok</b>, serta tim <b>Penelitian & Pengembangan dari Amerika</b>, Unimax menawarkan teknologi dengan:
                                            - <b>Kinerja unggul</b> & <b>stabilitas tinggi</b>
                                            - <b>Komponen elektronik</b> dan <b>pneumatik</b> yang andal dan tahan lama
                                            - Teknologi <b>otomasi modern</b> yang disesuaikan dengan kebutuhan industri spesifik

                                            Dengan semangat inovasi dan riset ilmiah yang kuat, kami merancang solusi otomatisasi yang:
                                            - Menjamin <b>efisiensi operasional</b>
                                            - Menghadirkan <b>akurasi pengujian maksimal</b>
                                            - Menyediakan <b>dukungan teknis berkualitas</b>
                                        </p>
                                        <p className="text-md text-gray-600 mb-6">
                                            <b>Unimax</b> hadir sebagai mitra terpercaya untuk memenuhi kebutuhan otomasi dan pengujian Anda, memastikan proses produksi yang lebih <b>efisien</b>, <b>aman</b>, dan <b>berkualitas tinggi</b>.
                                        </p>
                                    </div>
                                )}
                                <button
                                    onClick={onChangeExpand}
                                    className="text-blue-800 hover:text-blue-900 text-sm mt-2 mb-4 md:text-md cursor-pointer transition-colors duration-200">
                                    {isExpand ? 'Lihat selengkapnya' : 'Lihat lebih sedikit'}
                                </button>
                            </div>

                        </div>
                    </div>
                </section>
                <section className={"w-11/12 px-0 md:px-8 mx-auto"} style={{maxWidth:"1300px"}}>
                    <div className={"w-99 mx-auto"}>
                        <div className="flex flex-col md:flex-row gap-6">
                            {/* Misi */}
                            <div className="flex flex-col md:shadow py-4 cursor-pointer md:shadow-gray-200  rounded-lg md:border md:border-gray-100  transition-transform duration-300 ease-in-out hover:-translate-y-2  items-center md:items-start text-center md:text-left">
                                <div className={"w-11/12 mx-auto"}>
                                    <div className="bg-indigo-100 text-indigo-600 w-14  mx-auto md:mx-0 h-14 p-4 rounded-full mb-4">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeWidth="1.5"
                                            stroke="currentColor"
                                            className="w-6 h-6"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 0v8m0 4a4 4 0 100-8 4 4 0 000 8z"
                                            />
                                        </svg>
                                    </div>
                                    <h3 className="font-semibold text-lg  md:text-lg text-gray-900 mb-2">
                                        Misi Kami
                                    </h3>
                                    <p className="md:text-md text-sm text-gray-600">
                                        Kami berkomitmen untuk menyediakan solusi otomatisasi dan pengujian industri yang andal, dengan teknologi canggih yang mendukung efisiensi operasional, akurasi tinggi, dan keberlanjutan bagi setiap sektor industri.
                                    </p>
                                </div>
                            </div>

                            {/* Visi */}
                            <div className="flex flex-col md:shadow py-4 cursor-pointer md:shadow-gray-200  rounded-lg md:border md:border-gray-100  transition-transform duration-300 ease-in-out hover:-translate-y-2  items-center md:items-start text-center md:text-left">
                                <div className={"w-11/12 mx-auto"}>
                                    <div className="bg-indigo-100 text-indigo-600 w-14  mx-auto md:mx-0 h-14 p-4 rounded-full mb-4">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeWidth="1.5"
                                            stroke="currentColor"
                                            className="w-6 h-6"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M15.75 9V5.25M8.25 9V5.25M3 11.25h18m-15.75 0v7.5A2.25 2.25 0 007.5 21h9a2.25 2.25 0 002.25-2.25v-7.5"
                                            />
                                        </svg>
                                    </div>
                                    <h3 className="font-semibold text-lg  md:text-lg text-gray-900 mb-2">
                                        Visi Kami
                                    </h3>
                                    <p className="md:text-md text-sm text-gray-600">
                                        Menjadi pemimpin dalam menyediakan teknologi otomatisasi industri yang inovatif, memberikan solusi yang meningkatkan kinerja produksi, efisiensi biaya, dan kualitas hasil yang lebih baik untuk setiap klien kami.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id={"adddress"} className={"mz-10 mt-20"}>
                    <div className={"w-11/12 mx-auto"}  style={{maxWidth:"1500px"}}>

                        <div className={"w-full lg:w-10/12 mx-auto"}>
                            <div className={"w-full block"}>
                                <div className={"w-full md:w-11/12 mx-auto"}>
                                    <div className={""}>
                                        <div className={"w-full block md:flex gap-3 "}>
                                            <div className={"hidden rounded-lg  transition-transform duration-300 ease-in-out hover:-translate-y-2  bg-main w-full py-2  shadow"}>
                                                <div className={"w-98 mx-auto"}>
                                                    <div className={"my-3"}>
                                                        <p className={"text-gray-50 text-sm font-extralight"}>Lihat alamat kantor kami di bawah ini.</p>
                                                    </div>
                                                    <div>
                                                        <h1 className={"text-2xl font-semibold text-white"}>
                                                            Bizlink Citra Raya Jl. Pemda Tigaraksa No.106 Blok P03,
                                                            Tangerang Regency, Banten 15710
                                                        </h1>
                                                    </div>
                                                    <div>
                                                        <div>
                                                            <Link to={"https://maps.app.goo.gl/8Rxo18MGHkfUtjXZ8"}>
                                                                <button  className={"btn-main-bg-pink mt-4 mb-2 md:mt-4 md:mb-4  text-xs text-white rounded-lg"}>
                                                                    LIHAT MAPS
                                                                </button>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="w-full  rounded-lg  transition-transform duration-300 ease-in-out hover:-translate-y-2  relative md:w-11/12 mx-auto ">
                                                <div className="">
                                                    <iframe
                                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d991.5539264646015!2d106.49794494175971!3d-6.235272754221204!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69fbdea6f5b999%3A0xeba4ec77991aa84d!2sPT.%20Unitek%20Solusi%20Indonesia!5e0!3m2!1sen!2sus!4v1732599269627!5m2!1sen!2sus"
                                                        width="100%"
                                                        height="400"
                                                        style={{border: 0, borderRadius: "1rem"}}
                                                        allowFullScreen
                                                        loading="lazy"
                                                        referrerPolicy="no-referrer-when-downgrade">
                                                    </iframe>
                                                </div>
                                                <div className={"hidden md:block absolute top-0  bg-main w-5/12 left-0  mx-auto rounded-md py-2  shadow"}>
                                                    <div className={"w-11/12 mx-auto"}>
                                                        <div className={"my-3"}>
                                                            <p className={"text-gray-50 text-sm font-extralight"}>Lihat alamat kantor kami di bawah ini.</p>
                                                        </div>
                                                        <div className={"mb-3"}>
                                                            <h1 className={"text-lg font-semibold text-white"}>
                                                                Bizlink Citra Raya Jl. Pemda Tigaraksa No.106 Blok P03,
                                                                Tangerang Regency, Banten 15710
                                                            </h1>
                                                        </div>
                                                        <div>
                                                            <div>
                                                                <Link to={"https://maps.app.goo.gl/8Rxo18MGHkfUtjXZ8"} >
                                                                    <button className={"btn-main-bg-pink mt-4 mb-2 md:mt-2 md:mb-2  text-xs text-white rounded-lg"}>
                                                                        LIHAT MAPS
                                                                    </button>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className={"block absolute -bottom-16 md:hidden bg-main w-99 left-0 right-0 mx-auto rounded-md py-2  shadow"}>
                                                    <div className={"w-11/12 mx-auto"}>
                                                        <div className={"my-2"}>
                                                            <p className={"text-gray-50 text-sm font-extralight"}>Lihat alamat kantor kami di bawah ini.</p>
                                                        </div>
                                                        <div>
                                                            <h1 className={"text-md font-semibold text-white"}>
                                                                Bizlink Citra Raya Jl. Pemda Tigaraksa No.106 Blok P03,
                                                                Tangerang Regency, Banten 15710
                                                            </h1>
                                                        </div>
                                                        <div>
                                                            <div className={"mt-2 mb-1"}>
                                                                <Link to={"https://maps.app.goo.gl/8Rxo18MGHkfUtjXZ8"} >
                                                                    <button className={"btn-main-bg-pink mt-2 mb-2 md:mt-4 md:mb-4  text-xs text-white rounded-lg"}>
                                                                        LIHAT MAPS
                                                                    </button>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>

            </div>

        </>
    )
}

export const Information2Component = () => {

    const [isExpanded, setIsExpanded] = useState(false);
    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };
    return(
        <section id={"about"}>
            <div className={"mt-4 mb-2 md:my-10 "}>
                <div className={"pt-24 md:pt-10"}>

                    <div className={"w-full flex "}>
                        <div>
                            <div>

                            </div>
                        </div>
                        <div className={"w-full md:w-8/12  rounded-md pb-4 md:pt-10 md:pb-6 mx-auto"}>
                            <div className={"border bg-main rounded-xl pt-5  w-11/12 mx-auto border-gray-50 shadow "}>
                                <div className={"text-center block md:flex items-center"}>
                                    <div className={"mx-auto py-2 md:py-3 border-gray-200"}>
                                        <h1 className={" text-gray-200 text-xl md:text-2xl font-semibold "}>
                                            ABOUT US</h1>
                                    </div>
                                    <div className={"w-11/12 mx-auto"}>
                                        <div className={"mb-3 text-left md:text-center w-full md:w-8/12 mx-auto"}>
                                            <div className="w border-gray-200 md:py-0 py-3 px-2">
                                                <p
                                                    className={`text-md text-gray-300 ${
                                                        isExpanded ? "no-line" : "line-5"
                                                    }`}
                                                >
                                                    Unimax adalah Global Brand berorientasi teknologi modern yang
                                                    mengintegrasikan produksi, penelitian dan pengembangan, penjualan dan
                                                    layanan. Brand ini berspesialisasi dalam menyediakan solusi pengujian
                                                    lanjutan dan peralatan tingkat tinggi untuk makanan, obat-obatan, bahan
                                                    kimia sehari-hari, suku cadang mobil, dan proyek teknik lainnya.
                                                    Pembuat Produk Unimax adalah perusahaan besar yang berbasis di Shanghai,
                                                    Tiongkok dan Reseasrch and Development dari Amerika. Dengan kekuatan
                                                    penelitian ilmiah yang kuat dan semangat mengejar kualitas tinggi yang
                                                    tak henti-hentinya, produk ini dilengkapi dengan kinerja luar biasa,
                                                    komponen elektronik dan komponen pneumatik yang andal dan tahan lama,
                                                    memastikan kematangan seluruh teknologi peralatan, konfigurasi yang
                                                    wajar, kualitas stabil, dan kinerja unggul. Pada saat yang sama dengan
                                                    inovasi, perusahaan menggabungkan kondisi produksi aktual dan
                                                    karakteristik proses dari berbagai industri untuk merancang serangkaian
                                                    peralatan otomasi berkinerja tinggi dan berstabilitas tinggi untuk
                                                    berbagai produk dan kebutuhan pengguna yang berbeda.
                                                </p>
                                                <button
                                                    onClick={toggleExpand}
                                                    className="py-1.5 mt-4 text-center text-blue-800 hover:underline focus:outline-none"
                                                >
                                                    {isExpanded ? "Lihat lebih sedikit" : "Lihat selengkapnya"}
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"w-5/12 md:w-full ms-4 md:ms-auto "}>
                <div className={"bg-main py-1 rounded-full  md:py-5"}></div>
            </div>
        </section>
    )
}



export const ClientComponent = () => {
    const clients = Array.from({ length: 12 }, (_, i) => i + 1);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % clients.length);
        }, 2000); // Set interval for image change every 2 seconds

        return () => clearInterval(interval); // Clean up interval on unmount
    }, [clients.length]);

    return (
        <section id="client">
            <div className="mt-0 md:pt-28 ">
                <div className="w-full py-3 flex">
                    <div className="w-full md:-11/12 lg:w-9/12 pt-5 pb-0 border-t-2 border-gray-100 md:pt-10 md:pb-10 mx-auto">
                        <div className="text-center mt-10 md:mt-0 w-10/12 mx-auto block  md:flex items-center">
                            <div className="border-r-2 ms-auto md:pe-6 border-gray-100">
                                <h1 className="text-main text-2xl md:text-3xl font-semibold">
                                    KLIEN KAMI
                                </h1>
                            </div>
                            <div className="me-auto md:ms-0 md:ps-6 ms-auto md:me-auto">
                                <h4 className="text-red-600 font-semibold text-lg">Terpercaya oleh</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-full">
                    <div className={"md:-11/12 lg:w-10/12 hidden md:block  mx-auto"} style={{maxWidth:"1500px"}}>
                        <ul className="md:-11/12 lg:w-10/12 mx-auto flex flex-wrap">
                            {clients.map((client , index) => (
                                <li key={index} className="w-4/12">
                                    <div className="w-full  rounded-lg  transition-transform duration-500 ease-in-out hover:-translate-y-2 hover:scale-105">
                                        <div className="w-full h-24">
                                            <img
                                                className="w-full h-full object-contain"
                                                src={`/assets/client/client-${client}.png`}
                                                alt={`Client ${client}`}
                                            />
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>

                    </div>
                    <div className="w-full my-8 md:hidden block  md:w-10/12 mx-auto">
                        <ul className="w-11/12 md:w-10/12 mx-auto items-center justify-center block md:flex flex-wrap">
                            {clients.map((client, index) => (
                                <li
                                    key={index}
                                    className={`w-4/12 mx-auto md:mx-0 ${index === currentIndex ? 'opacity-100' : 'opacity-0 hidden'} transition-opacity duration-1000 ease-in-out`}
                                >
                                    <div className="w-full rounded-lg transition-transform duration-500 ease-in-out hover:-translate-y-2 hover:scale-105">
                                        <div className="w-full h-24">
                                            <img
                                                className="w-full h-full object-contain"
                                                src={`/assets/client/client-${client}.png`}
                                                alt={`Client ${client}`}
                                            />
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export const ContactComponent = () => {
    return(
        <div className={"md:pt-20"}>
            <div className={"md:pt-10"}>
                <div className={"w-full relative"}>
                    <div className={"w-full"}>
                        <ul className={" w-11/12 gap-4 block md:flex mx-auto"}>
                            <li className={"ms-auto w-full my-6 md:my-0 md:w-4/12"}>
                                <div className={"w-full"}>
                                    < Contact2CardComponent />
                                </div>
                            </li>
                            {/*<li className={"me-auto w-full my-6 md:my-0 md:w-4/12"}>*/}
                            {/*    <div className={"w-full"}>*/}
                            {/*        <ContactCardComponent />*/}
                            {/*    </div>*/}
                            {/*</li>*/}

                        </ul>
                    </div>


                </div>
            </div>
        </div>
    )
}

export const Contact2CardComponent =  () => {
    return(
        <div className={"block   bg-white w-full shadow-gray-400 border border-gray-50 mx-auto rounded-md py-2  shadow"}>
            <div className={"w-11/12 mx-auto"}>
                <div className={"mb-7 mt-4"}>
                    <div className={"mt-3 mb-2 text-center"}>
                        <p className={"text-gray-700 text-xl font-semibold"}>Hubungi Kami.</p>
                    </div>
                    <div className={"mb-3 text-center"}>
                        <h1 className={"text-sm font-medium text-gray-600"}>
                            Tanya kan pertanyaan, Harga dan Barang
                        </h1>
                    </div>
                </div>
                <div className={"w-full justify-between flex gap-4"}>
                    <div className={"w-5/12 mx-auto"}>
                        <div className="flex flex-col items-center md:items-start text-center md:text-left">
                            <div className="bg-indigo-100 text-indigo-600 p-4 rounded-full mb-4">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1.5"
                                    stroke="currentColor"
                                    className="w-6 h-6"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M15.75 9V5.25M8.25 9V5.25M3 11.25h18m-15.75 0v7.5A2.25 2.25 0 007.5 21h9a2.25 2.25 0 002.25-2.25v-7.5"
                                    />
                                </svg>
                            </div>
                            <h3 className="font-semibold text-lg text-gray-900 mb-2">
                                Kontak Kami
                            </h3>
                        </div>
                    </div>
                    <div className={"w-5/12 mx-auto"}>
                        <div className="flex flex-col items-center md:items-start text-center md:text-left">
                            <div className="bg-indigo-100 text-indigo-600 p-4 rounded-full mb-4">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1.5"
                                    stroke="currentColor"
                                    className="w-6 h-6"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M15.75 9V5.25M8.25 9V5.25M3 11.25h18m-15.75 0v7.5A2.25 2.25 0 007.5 21h9a2.25 2.25 0 002.25-2.25v-7.5"
                                    />
                                </svg>
                            </div>
                            <h3 className="font-semibold text-lg text-gray-900 mb-2">
                                Email Kami
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export const ContactCardComponent =  () => {
    return(
        <div className={"block   bg-main w-full   mx-auto rounded-md py-2  shadow"}>
            <div className={"w-11/12 mx-auto"}>
                <div className={"my-3"}>
                    <p className={"text-gray-50 text-sm font-extralight"}>Hubungi Kami.</p>
                </div>
                <div className={"mb-3"}>
                    <h1 className={"text-lg font-semibold text-white"}>
                        Tanya kan pertanyaan
                    </h1>
                </div>
                <div>
                    <div>
                        <Link to={"https://maps.app.goo.gl/8Rxo18MGHkfUtjXZ8"} >
                            <button className={"btn-main-bg-pink w-full mt-2 mb-2 md:mt-2 md:mb-2  text-xs text-white rounded-lg"}>
                                Via Email
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}